<script>
export default {
	name: "ExpandingTextarea",
	methods: {
		resize(event) {
			event.target.style.height = "auto";
			event.target.style.height = `${event.target.scrollHeight + 5}px`;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$el.style.height = `${this.$el.scrollHeight + 5}px`
		});
	},
	render() {
		return this.$scopedSlots.default({
			resize: this.resize
		});
	}
}
</script>